import FeaturesCard from './FeatureCard.vue';
export default {
  name: 'features',
  components: {
    FeaturesCard
  },
  props: {
    featuresList: {
      type: Array,
      default: () => []
    }
  }
};